module.exports = __webpack_public_path__ + "img/tr.dd0fd498.svg";